module.exports = __webpack_public_path__ + "img/201805-1.38b18842.jpeg";